import { GraphQLGroupRecommendationsRequester } from '@cobliteam/api-lib';
import type { GroupRecommendation } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useQuery } from '@tanstack/react-query';
import useUser from '../useEntity/useUser';
import useFeatureFlags from '../useFeatureFlags';
import useRegisterFleetRecommendations from '../useRegisterFleetRecommendations/useRegisterFleetRecommendations';

export type { GroupRecommendation };

export const GROUP_RECOMMENDATIONS_QUERY_KEY = 'GROUP_RECOMMENDATIONS';

// 10-min cache so repeated Groups visits reuse the persisted list instead of refetching.
const STALE_TIME_MS = 10 * 60 * 1000;

const groupRecommendationsRequester = new GraphQLGroupRecommendationsRequester();

// Backend owns the server-side eligibility gates; `enabled` stacks the cheap 0/1-group gate on top of the flag check.
const useGroupRecommendations = (options?: { enabled?: boolean }) => {
  const { getSession } = useUser();
  const fleetId = getSession()?.fleet?.id;
  const { aiGroupRecommendations } = useFeatureFlags();
  const enabled = !!fleetId && aiGroupRecommendations && options?.enabled !== false;

  useRegisterFleetRecommendations(enabled);

  return useQuery({
    // A chave NÃO leva a flag: useGroupRecommendationsMutation faz setQueryData nesta chave exata,
    // e um terceiro elemento faz a remoção otimista escrever num cache que ninguém lê.
    queryKey: [GROUP_RECOMMENDATIONS_QUERY_KEY, fleetId],
    queryFn: () => groupRecommendationsRequester.getGroupRecommendations(fleetId!),
    enabled,
    staleTime: STALE_TIME_MS,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useGroupRecommendations;
